import * as React from 'react'
import { Form, Input, Modal, TreeSelect } from 'antd'
import { FormInstance } from 'antd/lib/form'

import { IConfigurazioneService } from '../../services/ConfigurazioneService'
import container from '../../wires/Bootstrapper'
import SERVICE_IDENTIFIER from '../../wires/Identifiers'

import { TTFormItem } from '../shared/TTFormItem'
import { TTSimpleModalProps } from '../shared/TTModalProps'
import { CategoriaModel } from '../../models/ConfigurazioneModels'
import { DataNode } from 'rc-tree-select/lib/interface'

export enum OperationType {
    ADD,
    ADDFIRST,
    EDIT,
    DELETE
}

interface ModalCategoriaProps extends TTSimpleModalProps {
    id?: string
    do?: (obj?: any) => void;
    op: OperationType
}

class ModalCategoriaState {
    Categorie: Array<DataNode>
}

export class ModalCategoria extends React.Component<ModalCategoriaProps, ModalCategoriaState> {

    service: IConfigurazioneService
    formRef = React.createRef<FormInstance>()
    descRef = React.createRef<Input>()

    constructor(props) {
        super(props)
        this.state = new ModalCategoriaState()
        this.service = container.get(SERVICE_IDENTIFIER.CONFIGURAZIONE_SERVICE)
    }

    componentDidMount() {
        this.loadData()
        if (this.descRef.current != null)
            this.descRef.current.focus()
    }

    componentDidUpdate(prevProps: ModalCategoriaProps) {
        if (prevProps.visible == false && this.props.visible == true)
            this.descRef.current.focus()
    }

    loadData = async () => {
        if (this.props.op == OperationType.ADDFIRST) {
            let resp = await this.service.GetCategoria(null)
            if (resp.IsValid == true) 
                this.setState({ Categorie: resp.Categorie })
            debugger;
            this.formRef.current.setFieldsValue({ Categoria: this.props.id, Descrizione: "" })
        }
        else {
        let resp = await this.service.GetCategoria(this.props.id)
        if (resp.IsValid == true) {
            this.setState({ Categorie: resp.Categorie })
            if (this.props.id != null) {
                    this.formRef.current.setFieldsValue({ Categoria: this.props.op == OperationType.EDIT || this.props.op == OperationType.DELETE ? resp.Parent : resp.Id, Descrizione: this.props.op == OperationType.EDIT || this.props.op == OperationType.DELETE ? resp.Descrizione : "" })
                }
            }
        }
    }

    closeModal = () => {
        this.formRef.current.resetFields()
        this.props.closeModal()
    }

    onSave = async () => {
        try {
            let data = await this.formRef.current.validateFields()

            let model = new CategoriaModel()
            model.Id = this.props.op == OperationType.ADD || this.props.op == OperationType.ADDFIRST ? '00000000-0000-0000-0000-000000000000': this.props.id
            model.Descrizione = data.Descrizione
            model.Parent = data.Categoria

            let resp = await this.service.SaveCategoria(model)
            if (resp.IsValid == true) {
                if (this.props.do != null)
                    this.props.do()

                this.closeModal()
            }
        } catch (err) {
            console.log(err)
        }
    }

    render() {
        return (
            <Modal
                title={this.props.id == null ? "Crea categoria" : "Categoria"}
                width={700}
                visible={this.props.visible}
                onCancel={this.closeModal}
                onOk={this.onSave}>
                <Form ref={this.formRef}>
                    <TTFormItem label="Descrizione" name="Descrizione" rules={[{required: true}]}>
                        <Input ref={this.descRef} />
                    </TTFormItem>
                    <TTFormItem label="Categoria superiore" name="Categoria" rules={[{required: true}]}>
                        <TreeSelect
                            disabled={this.props.id != null}
                            style={{ width: '100%' }}
                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                            treeData={this.state.Categorie}
                            placeholder="Seleziona la categoria superiore"
                            treeDefaultExpandAll
                        />
                    </TTFormItem>
                </Form>
            </Modal>
        )
    }
}